// 栅格瓦片解析配置项
export var RasterTileType;

(function (RasterTileType) {
  RasterTileType["IMAGE"] = "image";
  RasterTileType["ARRAYBUFFER"] = "arraybuffer";
  RasterTileType["RGB"] = "rgb";
  RasterTileType["CUSTOMRGB"] = "customRGB";
  RasterTileType["CUSTOMARRAYBUFFER"] = "customArrayBuffer";
})(RasterTileType || (RasterTileType = {}));